'use strict';

const Mn = require('backbone.marionette');
require('backbone.stickit');
const GroupAction = require('common/domain/action/group');
const GroupRoleRepository = require('common/domain/repository/group-role');
const MemberCollection = require('common/domain/collection/member');
const MemberItemEditView = require('balus/ui/view/body/group/modal/member-edit/item');
const GroupMemberEditTemplate = require('balus/ui/template/body/group/modal/member-edit/index.hbs');

const MemberListEditView = Mn.CollectionView.extend({
    childView: MemberItemEditView,
    tagName: 'ul',
    className: 'list list-bordered',
    sort: false,
    childViewEvents: {
        'change:member': 'memberChanged'
    },
    childViewOptions: function() {
        return {
            context: this.getOption('context'),
            groupRoles: this.getOption('groupRoles')
        }
    },

    onRender: function() {
        this.$('[data-toggle="tooltip"]').tooltip();
    },

    memberChanged: function(){
        this.trigger('change:member');
    }
});

module.exports = Mn.View.extend({
    template: GroupMemberEditTemplate,
    regions: {
        memberList: '.member-list-wrapper'
    },
    childViewEvents: {
        'change:member': 'formFilled'
    },

    initialize: function() {
        this.collection = new MemberCollection(
            this.collection.map(m => m.clone()));
    },

    onRender: function() {
        GroupRoleRepository.find(this.model).fetchRoles()
            .then(groupRoles => {
                this.showChildView('memberList', new MemberListEditView({
                    context: this.getOption('context'),
                    collection: this.collection,
                    groupRoles: groupRoles
                }));
            });

        this.listenTo(this.collection, 'change add remove', this.enable);

        return this;
    },

    save: function() {
        return new Promise((resolve, reject) => {
            if(!this.model.isValid(true)) {
                reject();
            }

            let j = this.model.toJSON();
            j._members = this.collection.chain()
                .filter(function(m) {
                    return !m.get('deleting')
                })
                .map(function(m){
                    return {
                        user: m.get('user'),
                        role: m.get('role'),
                        suspended: m.get('suspended')
                    }
                })
                .value();

            GroupAction.updateGroup({
                group: j
            })
                .then(() => {
                    resolve();
                })
        });
    },

    formFilled: function(){
        this.trigger('formFilled');
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/group/modal/member-edit/index.js